import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography, Box } from '@mui/material';

// Loader Component
export  const SimpleLoader = ({ loadingText, textColor }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Optional background overlay
        width: '100vw',
        margin: 0,
        padding: 0,
      }}
    >
      {/* Circular Progress with dynamic color using sx */}
      <CircularProgress 
        size={50} 
        sx={{ mb: 2, color: textColor }} // Dynamic color
      />
      
      {/* Loading Text */}
      <Typography variant="h6" sx={{ color: textColor, fontWeight: 500 }}>
        {loadingText || "Loading... Please wait!"}
      </Typography>
    </Box>
  );
};


